module.exports = __webpack_public_path__ + "img/logo.45183bb7.svg";